import axios from "axios";

const baseURL =
  process.env.REACT_APP_COINGECKO_BASE_URL ||
  "https://api.coingecko.com/api/v3";

/**
 * Shared axios instance for CoinGecko (or any API using the same base).
 */
export const api = axios.create({
  baseURL,
  timeout: 25000,
  headers: {
    Accept: "application/json",
  },
});

function normalizeError(error) {
  const status = error.response?.status;
  const apiMessage = error.response?.data?.status?.error_message;
  const message =
    apiMessage ||
    error.response?.statusText ||
    error.message ||
    "Something went wrong";
  return { status, message, original: error };
}

api.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(normalizeError(error))
);

/**
 * Runs a request and returns a result object instead of throwing.
 * @template T
 * @param {() => Promise<{ data: T }>} executor
 * @returns {Promise<{ data: T | null; error: ReturnType<typeof normalizeError> | null }>}
 */
export async function requestHandler(executor) {
  try {
    const response = await executor();
    return { data: response.data ?? null, error: null };
  } catch (error) {
    if (
      error &&
      typeof error.message === "string" &&
      Object.prototype.hasOwnProperty.call(error, "status")
    ) {
      return { data: null, error };
    }
    return { data: null, error: normalizeError(error) };
  }
}
